import React from "react";
import DeviceWidget from "../../utils/DeviceWidget";
import Spinner from "react-spinner-material";
import Storage from "../../utils/storage";
import { PropTypes } from "prop-types";

const DocsUpload = ({
  categoryDocs,
  upload,
  isUploading,
  isFetching,
  disabled,
  handleDataFetch,
  handleRemoval,
  text,

}) => {
  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let categoryChoice = user && user.category_id;

  return (
    <div>
      {isFetching ? (
        <div className="center-spinner2">
          <br />
          <Spinner
            size={120}
            color={"#047558"}
            spinnerwidth={5}
            visible={true}
          />
        </div>
      ) : (
          <div>
            {categoryChoice !== 2 && categoryChoice !== 5 && categoryChoice !== 6 ? (
              <div>
                <div className="upload-files">
                  {categoryDocs &&
                    categoryDocs.map((category) => (
                      <DeviceWidget
                        id={category.id}
                        loaded={category.loaded}
                        url={category.url}
                        key={category.name}
                        title={category.title}
                        handleDataFetch={handleDataFetch}
                        name={category.name}
                        handleRemoval={handleRemoval}
                      />
                    ))}
                </div>
              </div>
            ) : (
                <div>
                  Not allowed
                </div>
              )}

            <div className="upload-button2">
              <button
                data-testid="upload"
                onClick={() => upload()}
                disabled={disabled}
              >
                {isUploading ? "Loading..." : text}
              </button>
            </div>
          </div>
        )}
    </div>
  );
};

DocsUpload.propTypes = {
  categoryDocs: PropTypes.array,
  disabled: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  handleDataFetch: PropTypes.func,
  handleRemoval: PropTypes.func,
  isFetching: PropTypes.bool,
  isUploading: PropTypes.bool,
  text: PropTypes.string,
  upload: PropTypes.func
}

export default DocsUpload;
